import QuickSuggestionsOptionState from '../store/schema/QuickSuggestionsOptionState';
import store from '../store/store';
import { OptionsCheckbox, OptionDescription } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import {
    getOptionsForFeature,
    SmartSuggestionsOptions,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';
import selectQuickSuggestionOption from '../actions/selectQuickSuggestionOption';
import { getFallbackValueIfNull } from 'owa-options-core';

export interface QuickSuggestionsFullProps {
    optionStore?: QuickSuggestionsOptionState;
    userOptions?: SmartSuggestionsOptions;
}

@reactive({
    optionStore: () => store,
    userOptions: () =>
        getOptionsForFeature<SmartSuggestionsOptions>(OwsOptionsFeatureType.SmartSuggestions),
})
export default class QuickSuggestionsFull extends React.Component<QuickSuggestionsFullProps, {}> {
    render() {
        let { optionStore, userOptions } = this.props;

        let isEnabled = getFallbackValueIfNull(
            optionStore.smartSuggestionsEnabled,
            userOptions.smartSuggestionsEnabled
        );
        let useLocation = getFallbackValueIfNull(
            optionStore.browserLocationEnabled,
            userOptions.browserLocationEnabled
        );

        return (
            <div>
                <OptionDescription>
                    {strings.options_mail_quickSuggestionsDescription}
                </OptionDescription>
                <OptionsCheckbox
                    checked={isEnabled}
                    label={strings.options_mail_quickSuggestionsEnable}
                    onChange={this.toggleEnable}
                />
                <OptionsCheckbox
                    disabled={!isEnabled}
                    checked={useLocation}
                    label={strings.options_mail_quickSuggestionsLocation}
                    onChange={this.toggleLocation}
                />
            </div>
        );
    }

    private toggleEnable(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) {
        selectQuickSuggestionOption('smartSuggestionsEnabled', checked);
    }

    private toggleLocation(
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) {
        selectQuickSuggestionOption('browserLocationEnabled', checked);
    }
}
